<template>
    <div
        class="form-table__body__td__append__tooltip__content">
        <v-tooltip top
                   v-if="tooltip.src && tooltip.src(byString(item.raw, header.key), item.raw)"
                   :disabled="!tooltip.text || !tooltip.text(byString(item.raw, header.key), item.raw)"
                   :color="tooltip.color && tooltip.color(byString(item.raw, header.key), item.raw)"
        >
            <template v-slot:activator="{ on, attrs }">
                <img v-on="on" :src="tooltip.src && tooltip.src(byString(item.raw, header.key), item.raw)" style="width: 20px; height: 20px;">
            </template>
            <span v-if="tooltip.text && tooltip.text(byString(item.raw, header.key), item.raw)">
                {{ tooltip.text(byString(item.raw, header.key), item.raw) }}
            </span>
        </v-tooltip>
    </div>
</template>

<script>
import tableUtilManager from "@/assets/plugins/mps-form-table/plugins/common/util/table-util-manager";

export default {
    name: "FormTableTdTooltip",
    props: {
        tooltip: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
        header: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        byString(o, s) {
            return tableUtilManager.byString(o, s);
        },
    }
}
</script>

<style scoped>
    .form-table__body__td .form-table__body__td__append__tooltip__content {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .form-table__body__td .form-table__body__td__append__tooltip__content:last-child {
    }
</style>